import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "no-tabs sent-geo-modal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sent_geo_modal = _resolveComponent("sent-geo-modal")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_sent_geo_modal, {
      ref: "sentGeoModalRef",
      onEmittedRefreshGrid: _ctx.getSentGeo,
      store: _ctx.store
    }, null, 8, ["onEmittedRefreshGrid", "store"]),
    _createElementVNode("a", {
      class: "btn btn-primary add-new",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAddModal && _ctx.openAddModal(...args)))
    }, [
      _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-plus" }, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('components.sentGeo.modals.addMonitoredTransport')), 1)
    ]),
    (_ctx.selectedItems.length > 0)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "btn btn-danger add-new",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
        }, _toDisplayString(_ctx.$t('components.sentGeo.modals.deleteSelected')), 1))
      : _createCommentVNode("", true),
    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('components.sentGeo.dataGrids.reportedShipmentMonitoring')), 1),
    _createVNode(_component_DxDataGrid, {
      ref: _ctx.dataGridRef,
      "allow-column-reordering": true,
      "allow-column-resizing": true,
      "column-auto-width": true,
      "column-hiding-enabled": true,
      "data-source": _ctx.store,
      "hover-state-enabled": true,
      "remote-operations": _ctx.remoteOperations,
      "show-borders": true,
      "show-column-lines": true,
      onSelectionChanged: _ctx.onSelectionChanged
    }, {
      "start-cell-template": _withCtx(({ data }) => [
        _createTextVNode(_toDisplayString(_ctx.getHumanDateTimeFromDateTime(data.data.start)), 1)
      ]),
      "stop-cell-template": _withCtx(({ data }) => [
        _createTextVNode(_toDisplayString(_ctx.getHumanDateTimeFromDateTime(data.data.stop)), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, {
          "show-check-boxes-mode": _ctx.showCheckBoxesMode,
          mode: "multiple"
        }, null, 8, ["show-check-boxes-mode"]),
        _createVNode(_component_DxHeaderFilter, { visible: true }),
        _createVNode(_component_DxPaging, {
          "page-index": 0,
          "page-size": 20
        }),
        _createVNode(_component_DxPager, {
          "show-info": true,
          "show-navigation-buttons": true,
          visible: true
        }),
        _createVNode(_component_DxFilterRow, { visible: false }),
        _createVNode(_component_DxColumnFixing, { enabled: true }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          width: 240,
          placeholder: _ctx.$t('components.sentGeo.dataGrids.search')
        }, null, 8, ["placeholder"]),
        _createVNode(_component_DxColumn, {
          "allow-filtering": true,
          "allow-header-filtering": false,
          caption: "#",
          "filter-operations": _ctx.allowedOperations,
          "data-field": "id",
          width: "100"
        }, null, 8, ["filter-operations"]),
        _createVNode(_component_DxColumn, {
          "allow-filtering": true,
          "allow-header-filtering": false,
          caption: _ctx.$t('components.sentGeo.dataGrids.vehicle'),
          "filter-operations": _ctx.allowedOperations,
          "data-field": "name"
        }, null, 8, ["caption", "filter-operations"]),
        _createVNode(_component_DxColumn, {
          "allow-filtering": true,
          "allow-header-filtering": false,
          caption: _ctx.$t('components.sentGeo.dataGrids.from'),
          "filter-operations": _ctx.allowedOperations,
          "cell-template": "start-cell-template"
        }, null, 8, ["caption", "filter-operations"]),
        _createVNode(_component_DxColumn, {
          "allow-filtering": true,
          "allow-header-filtering": false,
          caption: _ctx.$t('components.sentGeo.dataGrids.to'),
          "filter-operations": _ctx.allowedOperations,
          "cell-template": "stop-cell-template"
        }, null, 8, ["caption", "filter-operations"]),
        _createVNode(_component_DxColumn, {
          "allow-filtering": true,
          "allow-header-filtering": false,
          caption: _ctx.$t('components.sentGeo.dataGrids.referenceNumber'),
          "filter-operations": _ctx.allowedOperations,
          "data-field": "reference_number"
        }, null, 8, ["caption", "filter-operations"])
      ]),
      _: 1
    }, 8, ["data-source", "remote-operations", "onSelectionChanged"])
  ]))
}